<!-- 语音播放动态圆圈 -->
<template>
  <div
    class="audio__trigger"
    :class="[
      item.userId === currenData.userId && recordType === 0 ? 'trigger-left' : 'trigger-right',
      userid === item.userId ? 'self-info' : '',
    ]"
    @click="playAudioHandler(item, index)"
  >
    <div
      :class="[
        playKey === index && isPlaying === true ? 'wifi-symbol--avtive' : '',
        item.userId === currenData.userId && recordType === 0 ? 'wifi-symbol-left' : 'wifi-symbol-right',
      ]"
    >
      <div class="wifi-circle first" :class="userid === item.userId ? 'self-circle' : 'other-circle'"></div>
      <div class="wifi-circle second" :class="userid === item.userId ? 'self-circle' : 'other-circle'"></div>
      <div class="wifi-circle third" :class="userid === item.userId ? 'self-circle' : 'other-circle'"></div>
    </div>
    <div
      class="times"
      :class="item.userId === currenData.userId && recordType === 0 ? 'times-left' : 'times-right'"
      v-if="item.length != null"
    >
      {{ item.length + '″' }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
    },
    currenData: {
      type: [Object,Array],
    },
    userid: {
      type: String,
    },
    playKey: {
      type: Number,
    },
    index: {
      type: Number,
    },
    isPlaying: {
      type: Boolean,
    },
    recordType: {
      type: Number,
    },
  },
  data() {
    return {}
  },
  methods: {
    // 触发voice.vue 的playAudioHandler 事件
    playAudioHandler(item, index) {
      this.$emit('playAudioHandler', item, index)
    },
  },
  mounted() {},
  watch: {},
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'

.audio__trigger
  cursor pointer
  vertical-align top
  display inline-block
  line-height 32px
  height 32px
  width 100px
  border-radius 4px
  position relative
  .wifi-symbol-right
    position absolute
    right 4px
    top -8px
    width 50px
    height 50px
    box-sizing border-box
    overflow hidden
    transform rotate(-45deg) scale(0.5)
  .wifi-symbol-left
    position absolute
    left 4px
    top -8px
    width 50px
    height 50px
    box-sizing border-box
    overflow hidden
    transform rotate(135deg) scale(0.5)
  .wifi-circle
    border-radius 50%
    position absolute
  .first
    width 5px
    height 5px
    background #cccccc
    top 45px
    left 45px
  .second
    width 25px
    height 25px
    top 35px
    left 35px
  .third
    width 40px
    height 40px
    top 25px
    left 25px
  .times
    font-size 16px
    position absolute
  .times-left
    left 34px
  .times-right
    right 34px
  .wifi-symbol--avtive
    .second
      animation bounce 1s infinite 0.2s
    .third
      animation bounce 1s infinite 0.4s
.self-info
  background-color #1485EE
  color #fff
.self-circle
  border 5px solid #fff
.other-circle
  border 5px solid
.trigger-left
  float left
.trigger-right
  float right
@keyframes bounce
  0%
    opacity 0 /* 初始状态 透明度为0 */
  100%
    opacity 1 /* 结尾状态 透明度为1 */
.theme-dark
  .audio__trigger
    .times-left
      color #fff
    // .first
    //   background: #fff
    // .second
    //   background: #fff
    // .third
    //   background: #fff
</style>
